var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"lbCO2message\">\nCO2 emissions data is based on an average use of {{ vm.emissionsAverageDailyKilometers }}km per day\n<i class=\"lbCurrencyMessage_infoIcon\" lb-tooltip tooltip-content=\"vm.message\" tooltip-inline=\"true\"></i>\n</div>\n";
var id1="components/lbCO2Message/lbCO2Message.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbCO2Message/lbCO2Message.html
// module id = 1723
// module chunks = 5